import { Link, useLocation } from 'react-router-dom';
import { UserButton, SignedIn } from '@clerk/clerk-react';
import { useRole } from '../hooks/useRole';
import GlobalSearch from './GlobalSearch';

const navItems = [
  { path: '/', label: 'Dashboard' },
  { path: '/packs', label: 'Packs' },
  { path: '/cells', label: 'Cells' },
  { path: '/customers', label: 'Customers' },
  { path: '/tests', label: 'Test Logs' },
  { path: '/audit', label: 'Audit Logs' },
  { path: '/import', label: 'Import' },
];

export default function Navbar() {
  const location = useLocation();
  const { isEditor } = useRole();
  return (
    <nav className="relative z-50 hidden w-full max-w-full min-w-0 border-b border-gray-200 bg-white/80 shadow-sm backdrop-blur-md md:block">
      <div className="box-border w-full min-w-0 px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 min-w-0 items-center justify-between gap-3">
          <div className="flex min-w-0 flex-1 items-center gap-4 overflow-x-hidden lg:gap-8">
            <Link to="/" className="shrink-0 text-xl font-bold text-gray-900">
              BPI
            </Link>
            <div className="flex min-w-0 flex-1 flex-wrap items-center gap-1">
              {navItems
                .filter(item => {
                  if (item.path === '/import' || item.path === '/audit') {
                    return isEditor;
                  }
                  return true;
                })
                .map((item) => {
                  const isActive = location.pathname === item.path ||
                    (item.path !== '/' && location.pathname.startsWith(item.path));

                  return (
                    <Link
                      key={item.path}
                      to={item.path}
                      className={`shrink-0 whitespace-nowrap rounded-xl px-2.5 py-2 text-sm font-semibold transition-all duration-200 sm:px-4 ${isActive
                        ? 'bg-blue-600 text-white shadow-sm hover:bg-blue-700'
                        : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'
                        }`}
                    >
                      {item.label}
                    </Link>
                  );
                })}
            </div>
          </div>
          <div className="flex shrink-0 items-center gap-3">
            <div className="w-44 min-w-0 sm:w-56 lg:w-72 xl:w-80">
              <GlobalSearch />
            </div>
            <SignedIn>
              <UserButton afterSignOutUrl="/" />
            </SignedIn>
          </div>
        </div>
      </div>
    </nav>
  );
}
